module.exports = __webpack_public_path__ + "img/Jacke.ebd95c2f.png";